import { Routes } from '@angular/router';
import { ORDERING_AGENCY_CONFIG } from './base/ordering-agency-config';

export const orderingAgencyRoutes: Routes = [
  {
    path: ORDERING_AGENCY_CONFIG.routePath,
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/ordering-agency-list-page/ordering-agency-list-page.component'
          ).then((m) => m.OrderingAgencyListPageComponent),
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/ordering-agency-detail-page/ordering-agency-detail-page.component'
              ).then((m) => m.OrderingAgencyDetailPageComponent),
          },
        ],
      },
    ],
  },
];
